export default __webpack_public_path__ + "static/media/064.525778f3.svg";